
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { convertSocItemForTable, TSocItem_Table, API_TSocItem } from "@/models/soc_items";
import { API_ROUTES } from "@/utils/API";

@Component({
  components: {
    SocTableItemDescription: () => import("@/components/SocTable/SocTableItemDescription.vue"),
  },
})
export default class SocTableItem extends Vue {
  @Prop({ type: [String, Number] }) readonly value?: string;
  @Prop({ type: Boolean, default: true }) readonly small?: boolean;

  src: TSocItem_Table = ("" as unknown) as TSocItem_Table;

  async load(val: string) {
    if (!val) return;

    const { data } = await this.axios.get(API_ROUTES.GET_SOC_ITEM(val));

    if (!data) return;

    // TODO: Need to find the way to catch "Job title" better;
    const preparedData = ({
      soc_code: this.value,
      job_title: data.job_titles[0],
      description: data.description,
      entry: data.entry,
      tasks: data.tasks,
    } as unknown) as API_TSocItem;

    this.src = convertSocItemForTable(preparedData);
  }

  @Watch("value", { immediate: true, deep: true })
  onValueChange(val: string) {
    if (!val) return;

    this.load(val);
  }
}
